import { AuthedRoute } from "../../helpers/authed-route";
import {
  NamedRoute,
  route,
} from "../../../application/domain/routing/named-route";
import { SurveyContainer } from "./surveys";
import { SurveyDetailsContainer } from "./survey-detail";

export const SurveyR = {
  Surveys: route({
    path: "/surveys/surveys",
    component: SurveyContainer,
  }),
  SurveyResults: route({
    path: "/surveys/surveys/:id",
    link: (args: { id: string }) => `/surveys/surveys/${args.id}`,
    component: SurveyDetailsContainer,
  }),
};

export const SurveysRoute = () => {
  return (
    <>
      {Object.keys(SurveyR).map((k: string) => {
        const r = (SurveyR as { [key: string]: NamedRoute<any> })[k].forRouter;
        return (
          <AuthedRoute
            exact
            path={r.path}
            component={r.component}
            key={`SurveysRoute-${k}`}
          />
        );
      })}
    </>
  );
};
